module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedExtraBold.e2fcc64.woff2";